import React, { useContext, useEffect } from 'react';
import { Redirect, Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import WarningIcon from '@material-ui/icons/Warning';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import bgImage from "assets/images/vote-1.jpg";
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode';
import { AppContext } from "store/AppContext";


function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"© "}
      Þjóðskrá Íslands {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${bgImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(12, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  submit: {
    margin: theme.spacing(5, 0, 0),
  },
  form: {
    width: '100%',
  }
}));

const Villa = (props) => {
  const classes = useStyles();
  const context = useContext(AppContext);
  const cookies = new Cookies();
  const jwt = cookies.get('accesstoken');

  useEffect(() => {
    if (jwt !== undefined) {
      context.user.set(prevState => {
        return { ...prevState, jwt: jwt, details: jwtDecode(jwt) }
      });

      context.isLoggedIn.set(true);
    } else {
      console.warn('No accesstoken cookie found');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (context.isLoggedIn.get) {
    if (props.location.state !== undefined) {
      return <Redirect to={props.location.state.from} />;
    } else {
      return <Redirect to="/" />;
    }
  }

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Typography
            component="h1"
            variant="h4"
            style={{ marginBottom: "24px" }}
          >
            Kosningar utan kjörfundar
          </Typography>
          <Avatar className={classes.avatar}>
            <WarningIcon />
          </Avatar>
          <Typography
            component="h2"
            variant="h5"
            style={{ marginBottom: "24px" }}
          >
            Úps...Villa í innskráningu!
          </Typography>
          <Typography variant="h6">
            Ertu viss um að þú sért skráður notandi að þessu kerfi?
          </Typography>
          <Button
            className={classes.submit}
            variant="contained"
            size="large"
            component={Link}
            to={'/innskraning'}
            fullWidth
          >
            Aftur í innskráningu
          </Button>
        </div>
        <Copyright />
      </Grid>
    </Grid>
  );
}

export default Villa;